import React from "react";
import { motion } from "framer-motion";
import * as Lucide from "lucide-react";
import { WHY_CHOOSE } from "@/data/content";

export default function WhyChoose() {
  return (
    <section id="why" className="py-24 md:py-32 px-6 lg:px-10" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 mb-14 items-end">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#C9A227]" />
              <span className="overline">Why Travwave</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A2342] leading-[1.05]">
              Six reasons discerning travellers choose us.
            </h2>
          </div>
          <p className="text-[#6B7280] text-lg leading-relaxed">
            We are not a booking engine. We are a travel atelier — a small, devoted team of consultants who only design journeys worth talking about for years.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Ico = Lucide[w.icon] || Lucide.Sparkles;
            return (
              <motion.div
                key={w.title}
                data-testid={`why-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                className="lux-card p-8 group"
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#F8F9FB] to-white border border-gray-100 flex items-center justify-center mb-6 group-hover:from-[#C9A227]/15 group-hover:to-[#C9A227]/5 transition-colors duration-500">
                  <Ico className="w-6 h-6 text-[#C9A227]" />
                </div>
                <h3 className="font-display text-xl text-[#0A2342]">{w.title}</h3>
                <p className="mt-3 text-[#6B7280] leading-relaxed text-[15px]">{w.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
